'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var User =

// Base data
// username = '';
// avatarUrl = null;

// Auth Data
function User(initialData) {
    var _this = this;

    _classCallCheck(this, User);

    this.id = null;
    this.loggedIn = false;
    this.groups = [];
    this.realms = [];
    this.scope = '';
    this.token = null;
    this.refreshToken = null;
    this.firstname = '';
    this.lastname = '';
    this.displayname = '';
    this.dealer = null;
    this.app_metadata = {};
    this.created_at = null;

    this.extend = function (data) {
        var filteredData = {};
        for (var dataKey in data) {
            var dataValue = data[dataKey];
            if (typeof dataValue !== 'function') {
                filteredData[dataKey] = _lodash2.default.cloneDeep(dataValue);
            }
        }
        _lodash2.default.assign(_this, filteredData);
        _this.dealer = _this.app_metadata.dealerId;

        return _this;
    };

    if (initialData) this.extend(initialData);
}
// Access Data
;

exports.default = User;
//# sourceMappingURL=User.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/models/User.js
// module id = 610
// module chunks = 5